import session from 'auth/session';

// The session's user name, loaded by AuthGuard from /_auth/me before anything mounts —
// so this is a plain read, not a hook over async state.
export default function useAuthUserFullName(): string | undefined {
  return session.org?.userName || undefined;
}
